import { TIPTAP_APP_EMBED_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { AppEmbed as Component } from "./component";
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    name: TIPTAP_APP_EMBED_TYPE,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          type: null,
          itemId: null,
          name: null,
          imageSrc: null,
          url: null,
          image: null,
          bookingData: null,
          eventData: null
        })
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
